import React, { useEffect, useState, type Node } from 'react';
import { Button, Modal } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import { tracker } from 'angieslist-app-platform';
// eslint-disable-next-line import/extensions
import * as Cookies from 'js-cookie';
import './NewlyLinkedBusinessModal.scss';
import { defaultPageProps, defaultProps } from '../../../app/browser/analyticsDefaultProperties';

const activityLocation = 'sp : leads linking business modal';

const NewlyLinkedBusinessModal = (): Node => {
  const [businessName, setBusinessName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
    tracker.track('Item Clicked', {
      activityLocation,
      description: 'sp : leads linking business modal confirmation',
      ...defaultProps,
    });
  };

  const newlyLinkedBusinessCookieName = 'newly_linked_business';
  const newlyLinkedBusinessCookie = Cookies.get(newlyLinkedBusinessCookieName);

  useEffect(() => {
    if (newlyLinkedBusinessCookie) {
      setBusinessName(newlyLinkedBusinessCookie !== '' ? decodeURIComponent(newlyLinkedBusinessCookie.replace(/\+/g, ' ')) : 'your business');
      setShowModal(true);
      Cookies.remove(newlyLinkedBusinessCookieName, { domain: '.angi.com', path: '/' });
    }
  }, [newlyLinkedBusinessCookie]);

  useEffect(() => {
    if (showModal) {
      tracker.enhancedAnalyticsEvent(
        {
          type: 'page',
          name: activityLocation,
          properties: {
            activityLocation,
            ...defaultPageProps,
          },
        },
        {},
      );
    }
  }, [showModal]);

  return (
    <Modal show={showModal} onHide={() => closeModal(setShowModal)}>
      <Modal.Header className="newly-linked-business-modal-header">
        {`Done! We linked ${businessName} to your Angi account!`}
      </Modal.Header>
      <Modal.Body>
        <div className="newly-linked-business-modal-body-header">
          Now you can access all of your businesses with one Angi sign-in.
        </div>
        <div>
          <ul>
            <li>To manage one of your businesses, select it from this list.</li>
            <li>To link another business, select “Link a business” in the top right.</li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button id="newly-linked-business-modal-dismiss-button" bsStyle="primary-office" onClick={() => closeModal(setShowModal)}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default (compose(pure)(NewlyLinkedBusinessModal): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/NewlyLinkedBusinessModal.js